<template>
    <Breadcrumbs main="Ui Kits" title="Modal" />
    <div class="container-fluid">
        <div class="row">
            <basicModal />
            <sizeModel />
            <fullscreenModal />
            <centeredModal />
            <toggleModals />
            <staticModal />
            <customModals />
        </div>
    </div>
</template>
<script lang="ts" setup>
import { ref, defineAsyncComponent } from 'vue'
const basicModal = defineAsyncComponent(() => import("@/components/theme/uikits/modal/basicModal.vue"))
const sizeModel = defineAsyncComponent(() => import("@/components/theme/uikits/modal/sizeModel.vue"))
const fullscreenModal = defineAsyncComponent(() => import("@/components/theme/uikits/modal/fullscreenModal.vue"))
const centeredModal = defineAsyncComponent(() => import("@/components/theme/uikits/modal/centeredModal.vue"))
const toggleModals = defineAsyncComponent(() => import("@/components/theme/uikits/modal/toggleModals.vue"))
const staticModal = defineAsyncComponent(() => import("@/components/theme/uikits/modal/staticModal.vue"))
const customModals = defineAsyncComponent(() => import("@/components/theme/uikits/modal/customModals.vue"))
</script>